import React, { ReactNode } from 'react';

import { Text, TextProps } from '@rover/kibble/core';

interface TruncatedTextProps extends TextProps {
  children: ReactNode;
}
const TruncatedText: React.FC<TruncatedTextProps> = ({ children, sx = {}, ...props }) => {
  return (
    <Text
      sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, ...sx }}
      {...props}
    >
      {children}
    </Text>
  );
};

export default TruncatedText;
